import { Icon } from '@types';

export const Inbox = ({ customStyles, handleClick }: Icon) => (
	<svg
		className={customStyles}
		onClick={handleClick}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 64 40"
		enableBackground="new 0 0 64 40"
		fill="#FFF"
	>
		<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
		<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
		<g id="SVGRepo_iconCarrier">
			<title>Mail</title>
			<desc>Created with Sketch.</desc>
			<g id="Page-1">
				<g id="Mail" transform="translate(1.000000, 1.000000)">
					<path
						id="Shape"
						fill="none"
						stroke="#FFF"
						strokeWidth="2"
						d="M0,36c0,1.104,0.896,2,2,2h58 c1.104,0,2-0.896,2-2V2c0-1.104-0.896-2-2-2H2C0.896,0,0,0.896,0,2V36L0,36z"
					></path>
					<path
						id="Shape_4_"
						fill="none"
						stroke="#FFF"
						strokeWidth="2"
						d="M62,2 c0-1.104-31,22.032-31,22.032S0,1.144,0,2"
					></path>
					<path id="Shape_2_" fill="none" stroke="#FFF" strokeWidth="2" d="M61,37L37,20"></path>
					<path id="Shape_3_" fill="none" stroke="#FFF" strokeWidth="2" d="M1,37l24-17"></path>
				</g>
			</g>
		</g>
	</svg>
);
